import { render, staticRenderFns } from "./Docentes.vue?vue&type=template&id=461e07a2&"
import script from "./Docentes.vue?vue&type=script&lang=js&"
export * from "./Docentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports